export default "__VITE_ASSET__ClV8GjKX__"